///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { roundForNullableField } from "../../../helpers/laneCalculations";
import messages from "../../../helpers/messages";
import Tooltip from "../../Tooltip";
import InfoIcon from "../../icons/InfoIcon";
import { filterEquipmentTypes } from "../../../helpers/types";

export const LaneForecastInfo = ({ aggregatedForecastPricing, filters }) => {
  const formatNumber = number => {
    return number.toLocaleString("en-US");
  };

  const avgCost = formatNumber(
    roundForNullableField(aggregatedForecastPricing?.averageCost)
  );
  const avgCPM =
    aggregatedForecastPricing?.miles === 0
      ? avgCost
      : roundForNullableField(
          roundForNullableField(aggregatedForecastPricing?.averageCost) /
            aggregatedForecastPricing?.miles
        );

  let eq = filterEquipmentTypes.find(x => x.label === "V").label;

  if (filters.equipments?.length === 1) {
    if (
      filters.equipments[0].label === "V" ||
      filters.equipments[0].label === "R"
    ) {
      eq = filters.equipments[0].label;
    }
  }

  return (
    <span id="lane-forecast-details">
      <span className="weight--semibold font-size-14" id="lane-forecast">
        {messages.laneForecast.defaultMessage}:
      </span>
      <Tooltip
        content={messages.laneForecastInfoTooltip.defaultMessage}
        placement="top-end"
        offset={[-20, 10]}
      >
        <span id="lane-forecast-info-tooltip">
          <InfoIcon
            height={12}
            width={12}
            className="ml-4 mr-32 align-text-top"
            fill="#0066FA"
            title=""
          />
        </span>
      </Tooltip>

      <span className="weight--semibold" id="equip-type">
        {messages.equipType.defaultMessage}:{" "}
      </span>
      <span>{eq}</span>
      <Tooltip
        content={messages.laneForecastEquipTypeInfoTooltip.defaultMessage}
        placement="top-end"
        offset={[12, 10]}
      >
        <span id="equip-type-tooltip">
          <InfoIcon
            height={12}
            width={12}
            className="ml-4 align-text-top"
            fill="#0066FA"
            title=""
          />
        </span>
      </Tooltip>

      <span className="weight--semibold pl-16" id="avg-cost">
        {messages.averageCost.defaultMessage}:{" "}
      </span>
      <span className="pr-16">${avgCost}</span>

      <span className="weight--semibold" id="avg-cpm">
        {messages.averageCpm.defaultMessage}:{" "}
      </span>
      <span className="pr-16">${avgCPM}</span>

      <span className="weight--semibold" id="miles">
        {messages.miles.defaultMessage}:{" "}
      </span>
      <span className="pr-32">
        {formatNumber(aggregatedForecastPricing.miles)}
      </span>
    </span>
  );
};

export default LaneForecastInfo;
